import * as types from './actionTypes';
import atendimentoApi from '../api/atendimentoApi'


export function ObterAtendimentosCidadaoSuccess(enviado) {
    
    return { type: types.ENVIAR_PROTOCOLOS_CIDADAO, payload: enviado }
}

export function ObterAtendimentosCidadao(parametros) {
   
    return function (dispatch) {
        return atendimentoApi.ObterAtendimentosCidadao(parametros).then(ret => {
            
            dispatch(ObterAtendimentosCidadaoSuccess(ret));
        }).catch(error => {
            throw (error);
        });
    };
}



/** WEBPACK FOOTER **
 ** ./src/components/actions/atendimentoActions.js
 **/